import { forwardRef } from "react";
import { Dropdown } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import storage from "../services/storage";
import { resetAuth } from "../Store/auth/authReducer";
import navbarIcon from "../assets/images/navbar-icon.svg";
import greylead_head from "../assets/images/greyledread.png";

export const AccessDenied = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const logout = () => {
    storage.remove("user");
    storage.remove("class");
    storage.remove("sectionId");
    storage.remove("xAuthToken");
    storage.remove("lastBookId");
    storage.remove("searchParams");
    storage.remove("status");

    dispatch(resetAuth());
    navigate("/", { replace: true, state: { fromState: "instructor" } });
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 50,
        height: "100vh",
      }}
    >
      <NavBar logout={logout} />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          height: "inherit",
        }}
      >
        <div>
          <h1
            className="main_title"
            style={{ width: "740px", fontSize: "58px" }}
          >
            unable to validate with provided information
          </h1>
          <p
            className="have-account"
            style={{
              width: "752px",
              fontSize: "23px",
              lineHeight: "150%",
              paddingTop: "14px",
            }}
          >
            Greyled cannot verify your position at <b>University of lowa</b>{" "}
            based on the information provided. Please reach out to Greyled
            support to verify your position.
          </p>
          <p className="have-account" style={{ paddingTop: "20px" }}>
            Contact by email at{" "}
            <u style={{ fontWeight: "500" }}>support@greyled.com</u> or call{" "}
            <u style={{ fontWeight: "500" }}>123-456-7890.</u>
          </p>
          <div className="modal-btn" style={{ paddingTop: "30px" }}>
            <button type="button" className="btn-white-create mb-24">
              <a
                className="btn-white-create"
                href="https://www.greyled.com"
                target="_blank"
                rel="noreferrer"
                style={{ width: "inherit" }}
              >
                Go to Greyled home
              </a>
            </button>
            <button type="button" className="btn-white-create" onClick={logout}>
              Logout
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const NavBar = ({ logout }) => {
  const { user } = useSelector((state) => state.auth);

  return (
    <nav className="navbar navbar-default dashboard_header">
      <div className="navbar-header">
        <img
          src={greylead_head}
          alt="header photo"
          style={{ padding: "24px 0 0 40px" }}
        />
        <div className="right_bar">
          <ul>
            <li className="mr_9 cursor">
              <Dropdown>
                <Dropdown.Toggle
                  as={forwardRef(({ children, onClick }, ref) => (
                    // eslint-disable-next-line jsx-a11y/anchor-is-valid
                    <a
                      ref={ref}
                      onClick={(e) => {
                        e.preventDefault();
                        onClick(e);
                      }}
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      {user?.image ? (
                        <img
                          src={user?.image}
                          className="user_img_cre"
                          alt="profile_photo"
                          style={{
                            marginRight: "10px",
                          }}
                        />
                      ) : (
                        <div
                          className="profilePicture"
                          style={{ fontSize: "16px" }}
                        >
                          {user?.firstName?.[0]}
                          {user?.lastName?.[0]}
                        </div>
                      )}
                    </a>
                  ))}
                  id="dropdown-custom-components dropdown-button-drop-left"
                />
                <Dropdown.Menu style={{ cursor: "default" }}>
                  <Dropdown.Item
                    style={{
                      cursor: "default",
                      pointerEvents: "none",
                      userSelect: "none", // Prevents text selection
                      color: "gray", // Optional for a disabled look
                    }}
                  >
                    {user.firstName} {user.lastName}
                  </Dropdown.Item>

                  <Dropdown.Item onClick={logout}>Signout</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </li>
            <li className="menu_btn">
              <a
                href="#!"
                id="sidebarCollapse"
                className="btn btn-info navbar-btn"
              >
                <img src={navbarIcon} alt="navbar-icon" />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
